import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { UsersIcon } from '@heroicons/react/24/outline';

const GetContactPersonsNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-indigo-400 to-indigo-500 border-2 transition-all duration-200 ${
      selected ? 'border-indigo-600 shadow-xl scale-105' : 'border-indigo-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <UsersIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-indigo-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          <div className="text-xs text-indigo-100 mt-1">
            Kapcsolattartók lekérése
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Configuration preview */}
      {data.config && (
        <div className="mt-2 text-xs text-indigo-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <div className="space-y-1">
            {data.config.onlyWithEmail && (
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-indigo-200 rounded-full" />
                <span className="truncate">
                  Csak email címmel
                </span>
              </div>
            )}
            {data.config.onlyPrimary && (
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-indigo-200 rounded-full" />
                <span className="truncate">
                  Csak elsődleges
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution result */}
      {data.executionData && (
        <div className="mt-2 text-xs text-indigo-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <div className="flex items-center space-x-2">
            <div className={`w-2 h-2 rounded-full ${
              data.executionData.success ? 'bg-green-400' : 'bg-red-400'
            }`} />
            <span>
              {data.executionData.contactCount || 0} kapcsolattartó
            </span>
          </div>
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="customer"
        className="w-3 h-3 bg-white border-2 border-indigo-500"
        style={{ left: -6 }}
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="contacts"
        className="w-3 h-3 bg-white border-2 border-indigo-500"
        style={{ right: -6 }}
      />
    </div>
  );
};

export default GetContactPersonsNode;
